module.exports = __webpack_public_path__ + "static/img/Curtin.306195e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Curtin.jpg
// module id = k69J
// module chunks = 0